export const commandModel = {
   'name': {
      'title': "Name",
      'display': true
   },
   'collection_id': {
      'title': "Collection ID",
      'display': false,
      'metadata': true
   },
   'collection_id_name': {
      'title': "Collection",
      'display': true
   },
   'commands': {
      'title': "Commands",
      'display': false
   }
};